import io from 'socket.io-client'
import config from 'config'

const getEventNamespace = eventId => `/events/${eventId}`

const initSocket = namespace =>
  io(`${config.socket_server}${namespace}`, {
    transports: ['websocket'],
    autoConnect: false,
    upgrade: false,
    auth: {
      token: localStorage.token,
    },
  })

export { getEventNamespace, initSocket }
